import types from "./types";

const InitialState = {
  messageList: [],
  isFetchingMessages: false,
  messageListError: "",

  createdMessage: null,
  isCreatingMessage: false,
  messageCreateError: "",
};

export default (
  state = InitialState,
  action
) => {
  switch (action.type) {
    case types.GET_REQUEST_MESSAGES_REQUEST:
      return {
        ...state,
        isFetchingMessages: action.isFetchingMessages,
      }
    case types.GET_REQUEST_MESSAGES_COMPLETE:
      return {
        ...state,
        isFetchingMessages: action.isFetchingMessages,
        messageList: action.messageList
      }
    case types.GET_REQUEST_MESSAGES_ERROR:
      return {
        ...state,
        isFetchingMessages: action.isFetchingMessages,
        messageListError: action.messageListError
      }

    case types.SEND_REQUEST_MESSAGE_REQUEST:
      return {
        ...state,
        isCreatingMessage: action.isCreatingMessage,
      }
    case types.SEND_REQUEST_MESSAGE_COMPLETE:
      return {
        ...state,
        isCreatingMessage: action.isCreatingMessage,
        createdMessage: action.createdMessage
      }
    case types.SEND_REQUEST_MESSAGE_ERROR:
      return {
        ...state,
        isCreatingMessage: action.isCreatingMessage,
        messageCreateError: action.messageCreateError
      }
    default:
      return state;
  }
};
